import { parseWithZod } from '@conform-to/zod'
import { InquirySource } from '@prisma/client'
import { ActionFunctionArgs, MetaFunction, redirect } from '@remix-run/node'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Sentry from '@sentry/react'

import { contactFormSchema, ContactPage } from '~/features'
import { CustomError } from '~/lib'
import { createInquiry } from '~/models/inquiry.server'

export const meta: MetaFunction = ({ matches }) => {
  const parentMeta = matches
    .flatMap((match) => match.meta ?? [])
    .filter((meta) => !('title' in meta))
  return [
    ...parentMeta,
    { title: 'お問い合わせ | シェアオフィス コワーキングスペース検索サイト' },
  ]
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData()

  const submission = parseWithZod(formData, {
    schema: contactFormSchema,
  })

  if (submission.status !== 'success') {
    return submission.reply()
  }

  try {
    const result = await createInquiry({
      name: submission.value.name,
      organization: submission.value.organization,
      email: submission.value.email,
      phone: submission.value.phone,
      content: submission.value.content ?? '',
      inquirySource: InquirySource.FOOTER,
      contactInquiryTypes: submission.value.contactInquiryType,
    })

    if (!result.success) {
      throw new CustomError(result.message, {
        statusCode: result.statusCode,
      })
    }

    return redirect('/contact-success')
  } catch (error: unknown) {
    console.error('error', error)
    Sentry.captureException(error, {
      extra: { route: '/contact' },
    })

    if (error instanceof CustomError) {
      throw new Response(null, {
        status: error.statusCode,
      })
    }

    throw new Response(null, {
      status: 500,
    })
  }
}

export default function Index() {
  return <ContactPage />
}
